import styled, {css} from 'styled-components'
import {Collapse, colors, Colors, Images} from '@microfrontends/react-components';

export const BenefitCLPList = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: -10px;
    transition: all 0.25s;
    @media (max-width: 991px) {
        grid-template-columns: repeat(1, 1fr);
    }
`
export const ArrowIcon = styled(Images.ArrowDownIcon)<{ isCollapse?: boolean }>`
	transition: all 0.25s;
	width: 24px;
	height: 24px;
	${({ isCollapse }) =>
	isCollapse &&
	css`
			transform: rotate(-180deg);
			transition: all 0.25s;
		`}
`
export const IconWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`
export const CardCss = styled.div`
	width: 100%;
	height: auto;
	padding: 44px 24px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;
	border-radius: 12px;
	background-color: ${(props) => props.color ?? '#fff'};
	text-align: center;
`

export const BenefitName = styled.h4`
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	font-size: 14px;
	font-weight: 600;
	max-width: 224px;
	color: #333;
	height: 36px;
	line-height: 18px;
	position: relative;
	width: 100%;
	text-align: center;
`
export const Line = styled.span`
	content: '';
	width: 106px;
	height: 1px;
	background-color: ${colors.grey[90]};
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
`

export const BenefitDescription = styled.div<{ bgColor?: string }>`
	font-size: 14px;
	line-height: 24px;
	color: #333;
	height: 200px;
	overflow-y: auto;
	margin-bottom: 0;
	padding: 0 16px;
	width: 100%;
	white-space: pre-line;
	background-color: ${({ bgColor }) => bgColor ?? 'unset'};
`
export const HeaderCollapseCard = styled.div<{ bgColor: string }>`
	display: flex;
	align-items: center;
	background: ${({ bgColor }) => bgColor ?? '#fff'} !important;
	border: none;
	padding: 12px 20px;
	border-radius: 6px 6px 0 0;
	gap: 16px;
	max-height: 72px;
	font-weight: 600;
	span {
		max-width: calc(100% - 100px);
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
`
export const CollapseBtnBenefit = styled.button<{ isAbsolute: boolean }>`
	position: ${({ isAbsolute }) => (isAbsolute ? 'absolute' : 'static')};
	width: 100%;
	padding: 24px 12px;
	top: 0;
	right: 0;
	border: none !important;
	outline: none !important;
	margin-top: ${({ isAbsolute }) => (isAbsolute ? '0' : '10px')};
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 5px;
	background-color: transparent;
	color: ${Colors.text};
	transition: all 0.25s;
	cursor: pointer;
	font-weight: 500;
	opacity: 0.6;
	font-weight: 600;
`
export const BenefitList = styled.div<{ isMobile: boolean }>`
    display: flex;
    gap: 16px;
		margin-top: 24px;
    flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
`

export const ImageWrapper = styled.div`
    width: 184px;
    height: 80px;
    position: relative;
    display: inline-block;
`
export const CustomCollapse = styled(Collapse)`
	position: relative;
	border-radius: 6px;
`
